import type { FeedbackFormValues } from './types';

const MIN_AI_COMMENT_LENGTH = 10;
const ALPHANUMERIC_PATTERN = '[\\p{L}\\p{N}]';
const ALPHANUMERIC_CHARACTER = new RegExp(ALPHANUMERIC_PATTERN, 'u');

export const formValuesMapper = (values: FeedbackFormValues) => ({
  ...values,
  level: values.level?.value,
  english_level: values.english_level?.value,
});

export const canImproveCommentWithAi = (comment?: string) => {
  if (!comment) return false;

  const commentDocument = new DOMParser().parseFromString(comment, 'text/html');
  const commentText = commentDocument.body.textContent?.trim() || '';

  return commentText.length >= MIN_AI_COMMENT_LENGTH && ALPHANUMERIC_CHARACTER.test(commentText);
};
